import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import helpers from '../helper';
import SerLoader from '../loader/Service';
import Meta from './layout/Meta'

export default function Services() {
    const [services, setServices] = useState([]);
    const [servicecms, setServicecms] = useState();
    const [pageloader, setPageloader] = useState(false);

    useEffect(() => {
        setPageloader(true);
        async function fetchServicecms() {
            await axios.get(process.env.REACT_APP_API + 'api/getcmsdata/1')
                .then((response) => {
                    setServicecms(response.data.result);
                    setPageloader(false);
                });
        }
        fetchServicecms();
    }, [setServicecms]);

    useEffect(() => {
        
        async function fetchService() {
            await axios.get(process.env.REACT_APP_API + 'api/services').then((response) => {
                setServices(response.data.result.data);
                
            });
        }
        fetchService();
    }, [setServices]);
    return (
        <>
            <Meta id={7} />
            <main>
                <section className="InnerHead bgthm2">
                    <img loading="lazy" src={require("../assets/img/img-bg.svg").default} alt="Services" className="imgbg" width="1600" height="453" />
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-8 text-center">
                                <h1 className="fw-normal text-white">Services</h1>
                                <ol className="breadcrumb m-0 justify-content-center">
                                    <li className="breadcrumb-item"><Link to="/"><img src={require("../assets/img/home.svg").default} width="14" height="14" alt="Home" /></Link></li>
                                    <li className="breadcrumb-item"><span aria-current="page">Services</span></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="Sec2">
                    <div className="container">
                        {
                            servicecms ?
                                <div className="row justify-content-center">
                                    <div className="col-12 col-lg-8 text-center">
                                        <span className="SubTitle">{servicecms.title}</span>
                                        <h2 className="Heading">{servicecms.heading}</h2>
                                        <div dangerouslySetInnerHTML={{ __html: servicecms.description }} />
                                    </div>
                                </div>
                                :
                                ''
                        }

                        {
                            pageloader ?
                            <SerLoader />
                                :
                                <div className="row">
                                    {
                                        services.map((service, sr) =>
                                            <div className="col-md-6 mb-4" key={sr}>
                                                <Link to={'/service/' + service.alias} className="card SerBlock">
                                                    <div className="card-header">
                                                        {
                                                            helpers.helpers1(service.image) ?
                                                                <picture className="img">
                                                                    <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/service/' + service.image} alt={service.title} width="60" height="60" />
                                                                </picture>
                                                                :
                                                                <picture className="img">
                                                                    <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/service/webp/' + service.image + '.webp'} type="image/webp" />
                                                                    <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/service/avif/' + service.image + '.avif'} type="image/avif" />
                                                                    <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/service/jpg/' + service.image + '.jpg'} alt={service.title} width="60" height="60" />
                                                                </picture>
                                                        }
                                                    </div>
                                                    <div className="card-body px-4">
                                                        <h3 className="h5">{service.title}</h3>
                                                        <p>{service.short_description}</p>
                                                    </div>
                                                </Link>
                                            </div>
                                        )
                                    }
                                </div>
                        }

                    </div>
                </section>
            </main>
        </>
    )
}
